// import React from 'react';
import { styled } from '@mui/material/styles';
import { DualUseGoodsClobDto } from 'models/dtoTypes';
import SubSection from './_subSection';
import SdgScoreClob, { ISdgData } from './_sdgScoreClob';
import Empty from './_empty';
import { dualUseGoods } from 'kosmos/images';
import EsgLegand from './_esgLegand';

const PREFIX = '_dualUseGoodsReport';

const classes = {
  report: `${PREFIX}-report`,
};

const Root = styled('div')(() => ({
  position: 'relative',
  width: '100%',
  [`& .${classes.report}`]: {
  },
}));

interface IProps {
  name?: string;
  dualUseGoodsReport: DualUseGoodsClobDto[];
}

export default function DualUseGoodsReport(props: IProps): JSX.Element {
  const { name = 'Dual Use Goods', dualUseGoodsReport } = props;

  const renderSingleClob = (item: DualUseGoodsClobDto, index: number) => {
    const { entitySummaryCode, entitySummaryDetail, affinity } = item;
    const code: string = entitySummaryCode || 'Unknown';
    const desc: string = entitySummaryDetail || 'Unknown';
    const title = `${code} - ${desc}`;

    return (
      <SdgScoreClob
        withBorder={true}
        withBg={true}
        key={index}
        title={title}
        affinity={affinity}
      />
    );
  };

  const renderLegands = () => {
    const legands: ISdgData[] = [
      {
        affinity: 'negative',
        title: 'Business products identified as used for military purpose.',
        withBg: true,
        size: 'small',
      },
      {
        affinity: 'warning',
        title: 'Business products identified as a dual-use good and potentially used for military purpose.',
        withBg: true,
        size: 'small',
      },
      {
        affinity: 'positive',
        title: 'Business products identified as non-dual-use good.',
        withBg: true,
        size: 'small',
      },
    ];

    return (
      <EsgLegand
        legands={legands}
        title="Activity check against dual-use goods lists. "
        learnMoreTabId="dug"
      />
    );
  };

  const renderContent = () => {
    if (dualUseGoodsReport.length === 0) {
      return <Empty title="There is no data available"/>;
    }

    return (
      <Root>
        {dualUseGoodsReport.map(renderSingleClob)}
      </Root>
    );
  };

  return (
    <SubSection
      title={name}
      isBold
      icon={<img src={dualUseGoods} />}
    >
      <>
        {renderLegands()}
        {renderContent()}
      </>
    </SubSection>
  );
}

